import React, { useState, useEffect } from 'react';
import { FaArrowRightLong, FaArrowLeftLong } from "react-icons/fa6";
import test from "../../Assets/testi.jpg";

const testimonials = [
  { name: 'John Doe', feedback: 'RDS has exceeded our expectations with their excellent service and commitment to quality.' },
  { name: 'Priya R.', feedback: 'Truly professional team! Their timely delivery and customer support are unmatched.' },
  { name: 'Akash Mehta', feedback: 'We are very happy with our new home. RDS made our dream come true!' },
  { name: 'Meera S.', feedback: 'Their dedication to sustainability and innovation is highly commendable.' },
  { name: 'Rahul Nair', feedback: 'Exceptional work ethics and trustworthy service from start to finish.' },
  { name: 'Divya Kumar', feedback: 'The team at RDS made the entire process so smooth and stress-free.' },
  { name: 'Vikram Patel', feedback: 'It’s rare to find a builder who delivers on every promise. Highly recommended!' },
];

const Recognized = () => {
  const [startIndex, setStartIndex] = useState(0);
  const visibleCards = 4;

  const handlePrev = () => {
    setStartIndex((prev) => Math.max(prev - 1, 0));
  };

  const handleNext = () => {
    setStartIndex((prev) => {
      const nextIndex = prev + 1;
      return nextIndex > testimonials.length - visibleCards ? 0 : nextIndex;
    });
  };

  // Auto slide every 4 seconds
  useEffect(() => {
    const interval = setInterval(() => {
      handleNext();
    }, 4000);
    return () => clearInterval(interval); // Clean up on unmount
  }, []);

  const isMobile = typeof window !== "undefined" && window.innerWidth < 640;
  const visibleTestimonials = isMobile
    ? testimonials
    : testimonials.slice(startIndex, startIndex + visibleCards);

  return (
    <div className='bg-[#fdfbf0] py-8 px-4 max-w-screen-3xl mx-auto'>
      {/* Title Section */}
      <div className="flex flex-col sm:flex-row items-center justify-center space-y-4 sm:space-y-0 sm:space-x-6 mb-4 text-center">
        <div className="w-40 sm:w-72 h-0.5 bg-gray-300"></div>
        <h1 className="text-xl sm:text-2xl font-bold text-gray-800 whitespace-nowrap">
          WHAT OUR CUSTOMERS SAY
        </h1>
        <div className="w-40 sm:w-72 h-0.5 bg-gray-300"></div>
      </div>

      <h1 className='text-gray-700 text-lg sm:text-2xl text-center font-sans mb-10'>
        “Hear directly from our happy customers.”
      </h1>

      {/* Slider Section */}
      <div className='flex items-center justify-center space-x-2 sm:space-x-4'>
        <button onClick={handlePrev} className='p-2 rounded-full border-2 border-gray-500 border-dashed hidden sm:flex'>
          <FaArrowLeftLong size={24} className='text-gray-500' />
        </button>

        <div className="flex overflow-x-auto sm:overflow-hidden space-x-4 sm:space-x-6 scrollbar-hide">
          {visibleTestimonials.map((card, idx) => (
            <div
              key={idx}
              className="md:min-w-[240px] min-w-[160px] sm:w-72 bg-white shadow-lg mb-6 p-5 rounded-tr-3xl rounded-tl-3xl rounded-bl-3xl flex flex-col items-start justify-between flex-shrink-0"
            >
              <div className="text-yellow-500 text-3xl mb-3">
                <img src={test} alt="" className='h-12 w-12' />
              </div>
              <h3 className="text-lg font-bold text-gray-800 mb-2">{card.name}</h3>
              <p className="text-sm text-gray-600 leading-relaxed italic">
                “{card.feedback}”
              </p>
            </div>
          ))}
        </div>

        <button onClick={handleNext} className='p-2 rounded-full border-2 border-gray-500 border-dashed hidden sm:flex'>
          <FaArrowRightLong size={24} className='text-gray-500' />
        </button>
      </div>
    </div>
  );
};

export default Recognized;